import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationDialogComponent} from '../repair-details/confirmation-dialog/confirmation-dialog.component';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material';
import {ToastMessagesService} from '../services/toast-messages.service';
import {MatTableDataSource} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {CancellationAccessoryLoadingDialogComponent} from './cancellation-accessory-loading-dialog/cancellation-accessory-loading-dialog.component';
import {ActionCompletionDialogComponent} from "../common/action-completion-dialog/action-completion-dialog.component";

@Component({
  templateUrl: './accessory-loading-order-details.component.html'
})
export class AccessoryLoadingOrderDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public orderDetails: any;
  public commandID: number;
  requestsCount: number;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  details: any = [];
  pageInitialized: boolean;
  order: any;
  public tableContainerWidth: any;

  public displayedColumns: string[] = ['serial_number', 'material_id', 'material_description', 'all_values_loaded', 'date_completed'];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              public commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.pageInitialized = false;
    this.showBasicInfo = false;
    this.dataSource = new MatTableDataSource<any>([]);
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.tableContainerWidth = window.innerWidth - 310;
      this.activatedRoute.params.subscribe(async (params) => {
        this.loadingService.show();
        this.commandID = params.id;
        this.details = await this.commonService.getSimpleList(`accessory_request/loading_command/${params.id}`);
        this.dataSource = new MatTableDataSource<any>(this.details.details);
        this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
        this.dataSource.sort = this.sort;
        await this.initUser();
        this.pageInitialized = true;
        this.loadingService.hide();
      });
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.commandID
        }
      ],
      title: 'Πληροφορίες Εντολής Φόρτωσης Θηκών'
    };

    this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    const action = {
      function: () => {
        this.initializeConfirmCancellationDialog();
      },
      showAction: this.canShowDelete(),
      title: 'Διαγραφή Εντολής Φόρτωσης',
      icon: 'cancel',
      color: 'red'
    };

    const action2 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };

    const action3 = {
      function: () => {
        this.cancelFullLoadingOrder();
      },
      showAction: this.canShowCancelButton(),
      title: 'Ακύρωση εντολής φόρτωσης',
      icon: 'block',
      color: '#013e81',
    };

    if (this.user.role_alternate_name === 'hqManager') {
      // actions.push(action2);
    } else {
      actions.push(action);
      // actions.push(action2);
      actions.push(action3);
    }

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  canShowCancelButton(): boolean {
    return this.details.info.status_id === 1;
  }

  cancelFullLoadingOrder() {
    const dialog = this.matDialog.open(CancellationAccessoryLoadingDialogComponent, {
      width: '650px',
      data: {
        id: this.commandID,
        title: `Ακύρωση Εντολής Φόρτωσης Θηκών ${this.commandID}`
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.matDialog.open(ActionCompletionDialogComponent, {
          data: {
            buttonText: 'Πλοήγηση στις εντολές φόρτωσης θηκών',
            redirectURL: `accessory_loading_commands`
          }
        });
      }
    });
  }

  private canShowDelete() {
    return this.details.info.status_id === 1;
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=loading_command&id= ${this.commandID}`,
        `Εντολή Φόρτωσης Θηκών - ${this.commandID}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async initializeConfirmCancellationDialog() {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή φόρτωσης με αριθμό ${this.commandID}?`,
        title: 'Διαγραφή εντολής φόρτωσης'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.deleteCommand();
      }
    });
  }

  private async deleteCommand() {
    try {
      await this.commonService.deleteRecord(`accessory_request/loading_command/${this.commandID}`);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['accessory_loading_commands']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

}
